import React, {useState} from 'react'

export default function TextForm(props) {

    const [text,setText]=useState("");
    const handleUpperCase=()=>{
            let newText = text.toUpperCase();
            setText(newText);

    }
    const handleChange=(event)=>{
        setText(event.target.value);
       // props.showAlert('Converted to Uppercase Text', 'success');
        
    }

    const handleLowerCase=()=>{
        let newText=text.toLowerCase();
        setText(newText);
       // props.showAlert('Converted to Lowercase Text', 'success');
    }

    const reset=()=>{
        let newText="";
        setText(newText);
        //props.showAlert('Reset Done', 'success');
    }

    const copyText=()=>{
        let newText=document.getElementById("textbox");
        newText.select();
        navigator.clipboard.writeText(newText.value);
        text===''?console.log('No Text to Copy'):props.showAlert('Text Copied to Clipboard', 'success');
    }
    return (
        <>
        <div className={`container ${props.mode==='dark'?'text-light':'text-dark'}`}>
            <h1>{props.heading}</h1>
            <div className="mb-3">
            <textarea className={`form-control ${props.mode==='dark'?'text-light':'text-dark'} ${props.mode==='dark'?'bg-dark':'bg-light'}`} id="textbox" rows="10" value={text} onChange={handleChange} placeholder='Enter Your Text Here'></textarea>
            </div>
            
            <button disabled={text.length===0} className="btn btn-primary  mx-2 my-1" onClick={handleUpperCase}>Convert Into UpperCase</button>
            <button disabled={text.length===0} className="btn btn-primary mx-2 my-1" onClick={handleLowerCase}>Convert Into LowerCase</button>
            <button disabled={text.length===0} className="btn btn-primary mx-2 my-1" onClick={reset}> &#160; &#160; Reset  &#160;  &#160;</button>
            <button disabled={text.length===0} className="btn btn-primary mx-2 my-1" onClick={copyText}> &#160; Copy Text &#160;</button>
            
        </div>
        <div className={`container my-2 ${props.mode==='dark'?'text-light':'text-dark'}`}>
            <table><tbody>
            <tr><th colSpan="4"><u>Text Summary: </u></th></tr>
            <tr><td><b>No. of Words:</b> {text.split(" ").filter((element)=>{return element.length!==0;}).length}  &#160; &#160;  &#160;  &#160; </td>
            <td><b>No. of Characters: </b>{text.length}  &#160; &#160;  &#160;  &#160; </td>
            <td><b>Time needed to read: </b>{text.length*0.008} minutes  </td></tr>
            </tbody></table>
            <h4><u>Preview: </u></h4>
            <p>{text.length===0?'Nothing to Preview':text}</p>

        </div>
        </>
    )
}
